import { bigBlueButtonIntegrationApi } from "@/api";
import { useAddAlert } from "@/hooks/useAddAlert";
import { useState } from "react";
import { useSelector } from "react-redux";

export const useCreateLonkToMeeting = () => {
    const addAlert = useAddAlert();
    const [isCreatingLink, setIsCreatingLink] = useState(false);

    const bigBlueButtonAutoStartRecording = useSelector(
        (state) => state.settings?.bigBlueButtonAutoStartRecording === '1'
    );

    const bigBlueButtonAutoSaveLessonRecordings = useSelector(
        (state) => state.settings?.bigBlueButtonAutoSaveLessonRecordings === '1'
    );

    const createLonkToMeeting = async (
        {
            direction_id,
            speaker_id,
            report_id
        }
 
         ) => {
        setIsCreatingLink(true);
        try {
            const res = await bigBlueButtonIntegrationApi.createMeeting({
                direction_id,
                speaker_id,
                report_id,
                record: bigBlueButtonAutoStartRecording ? true : false,
                returnInLessonsVideosSave: bigBlueButtonAutoSaveLessonRecordings ? true : false,
            });

            if (res?.data?.status === 'success') {
                const joinUrl = res?.data?.data?.joinUrl ?? '';
                const joinUrlForChildren = res?.data?.data?.joinUrlForChildren ?? '';

                if (!joinUrl) {
                    addAlert({
                        title: 'Ошибка',
                        text: 'Импульс-ВКС: не удалось получить ссылку на встречу',
                        type: 'error',
                    });
                    return {
                        status: 'error'
                    }
                }

                return {
                    status: 'sussess',
                    link: joinUrl,
                    linkForChildren: joinUrlForChildren
                };
            }

            addAlert({
                title: 'Ошибка',
                text: res?.data?.error?.[0] ?? 'Импульс-ВКС: не удалось создать встречу',
                type: 'error',
            });
        } catch (e) {
            addAlert({ title: 'Ошибка', text: 'Импульс-ВКС: не удалось создать встречу', type: 'error' });
        } finally {
            setIsCreatingLink(false);
        }
    }
    
    return {
        isCreatingLink,
        createLonkToMeeting
    }
};
